import React from 'react';
import ErrorBoundary from '../../../v2BaseComponents/ErrorBoundary';
import { ActionButtonLayout } from '../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../v2BaseComponents/MainContentContainer';
import Stack from '../../../v2BaseComponents/Stack';
import { getSpacing } from '../../../../utils/spacing';
import LoginButtons from './LoginButtons';
import Footer from './Footer';
import SplashScreenBackground from '../../../v2BaseComponents/SplashScreenBackground';
import TitleLogo from '../../../shared/TitleLogo';

export type NativeWelcomeScreenOwnProps = {};

export type NativeWelcomeScreenProps = NativeWelcomeScreenOwnProps;

const NativeWelcomeScreen: React.FC<NativeWelcomeScreenProps> = (_props) => {
    return (
        <ErrorBoundary>
            <SplashScreenBackground>
                <ActionButtonLayout scrollable restrictedWidthVariant="md" disableBackground>
                    <MainContentContainer>
                        <Stack vertical space={getSpacing(6)}>
                            <TitleLogo />
                            <Stack
                                space={getSpacing(1)}
                                horizontal
                                style={{
                                    alignSelf: 'stretch',
                                    marginTop: getSpacing(10),
                                    marginBottom: getSpacing(10),
                                }}
                                justify="center"
                                testID="social-login-button-container"
                            >
                                <LoginButtons />
                            </Stack>
                            <Footer />
                        </Stack>
                    </MainContentContainer>
                </ActionButtonLayout>
            </SplashScreenBackground>
        </ErrorBoundary>
    );
};

export default React.memo(NativeWelcomeScreen);
